import calender from "../assets/Events/UpcomingEvents/calender.png";
import location from "../assets/Events/UpcomingEvents/MapMarker.png";

export const upcomingEventList = [
  {
    image:
      "https://images.unsplash.com/photo-1438232992991-995b7058bbb3?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8OHx8Y2h1cmNofGVufDB8fDB8fHww",
    date: "18",
    month: "Apr",
    title: "EXPLORING THE CHRISTIAN FAITH",
    calenderIcon: calender,
    time: "08:00 AM - 11:00 AM",
    locationIcon: location,
    location: "Namchi ,Sikkim 737126",
  },
  {
    image:
      "https://images.unsplash.com/photo-1507692049790-de58290a4334?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8N3x8Y2h1cmNofGVufDB8fDB8fHww",
    date: "18",
    month: "Apr",
    title: "To love and, to cherish the wedding",
    calenderIcon: calender,
    time: "08:00 AM - 11:00 AM",
    locationIcon: location,
    location: "Namchi ,Sikkim 737126",
  },
  {
    image:
      "https://images.unsplash.com/photo-1526746323784-6bc814d79273?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nzh8fGNodXJjaHxlbnwwfHwwfHx8MA%3D%3D",
    date: "18",
    month: "Apr",
    title: "EXPLORING THE CHRISTIAN FAITH",
    calenderIcon: calender,
    time: "08:00 AM - 11:00 AM",
    locationIcon: location,
    location: "Namchi ,Sikkim 737126",
  },
  {
    image:
      "https://images.unsplash.com/photo-1526746323784-6bc814d79273?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nzh8fGNodXJjaHxlbnwwfHwwfHx8MA%3D%3D",
    date: "18",
    month: "Apr",
    title: "EXPLORING THE CHRISTIAN FAITH",
    calenderIcon: calender,
    time: "08:00 AM - 11:00 AM",
    locationIcon: location,
    location: "Namchi ,Sikkim 737126",
  },
];
